function isInReviewerApproverPage() {
  return $("#reviewerApproverPage").length > 0;
}

if (isInReviewerApproverPage()) {
  var grantId = $("#grantId").val();
  var popupFlag = false;

  var dialogSelector = "#approver-change";


  var thisSelect = $("#paymentApprover").val();
  var prevSelect = "";

  $("#paymentApprover").on("change", function () {
    var rowLength = $("table tbody").find("tr").length;
    prevSelect = thisSelect;
    thisSelect = $(this).val();
    //            getJson(grantId, $("#paymentApprover").val());
    if (popupFlag) {
      $(dialogSelector)[0].showModal();
    } else {
      getJson(grantId, $("#paymentApprover").val());
    }
  });

  if ($("#paymentApprover").val() != null) {
    getJson(grantId, $("#paymentApprover").val());
  }

  $(".js-threshold-add").click(function () {
    if (!require("./thresholdValidation")($(this).closest("table"))) {
      return;
    }
    popupFlag = true;
    addToTable($(this).closest("tr"));
  });

  $("#approver-change .dialog-proceed-approval").click(function () {
    popupFlag = false;
    getJson(grantId, $("#paymentApprover").val());
    var id = $(dialogSelector)[0].id;
    var dialog = document.getElementById(id);
    dialog.close();
  });
  $("#approver-change .dialog-cancel-approval").click(function () {
    var id = $(dialogSelector)[0].id;
    var dialog = document.getElementById(id);
    $("#paymentApprover").val(prevSelect);
    $("#paymentApprover").trigger("chosen:updated");
    dialog.close();
  });

  function getJson(grantId, userId) {
    //        console.log(formData);
    $.ajax({
      dataType: "JSON",
      url:
        "/setup/grants/grant/api/approval-thresholds?id=" +
        grantId +
        "&userId=" +
        userId,
      //            data: $("#transactionsReportCommand").serialize()
    })
      .done(function (response) {
        displayThresholdTable(response);
      })
      .fail(function (response) {
        var totalSection = $("#totalGrantSections").val();
        $("#fractionValue").text(0);
        $("#thresholdBody").empty();

        /*var jsonResponse = {"approvalThresholds":[
                        {"abatement-value": "0",
                        "grantId" : "javhggfytgytgy",
                        "grantSectionId" : "jhgaydagyasdgd",
                        "grantSectionName": "tr-sec-01",
                        "payment-value": "58000"
                    },
                    {"abatement-value": "234",
                                            "grantId" : "javhggfytgytgy",
                                            "grantSectionId" : "jhgaydagyasdgd",
                                            "grantSectionName": "tr-sec-02",
                                            "payment-value": "523000"
                                        }]}

                    displayThresholdTable(jsonResponse);*/
      });
  }

  function displayThresholdTable(response) {
    var tableVal = response;
    var rowDataObject = tableVal["approvalThresholds"];
    $("#thresholdBody").empty();
    var $table = $("table tbody");
    var i = 0;
    var thresholdObj = { thresholds: [] };
    rowDataObject.forEach(function (arrayItem) {
      var $tr = $('<tr class="govuk-table__row"></tr>');
      var grantSection = arrayItem["grantSectionName"];
      var grantSectionId = arrayItem["grantSectionId"];
      var paymentsThreshold = arrayItem["payment-value"];
      var abatementsThreshold = arrayItem["abatement-value"];
      var grantId = arrayItem["grantId"];
      var currentGrantId = $("#grantId").val();
      if (grantId == currentGrantId) {
        var $td1 = $(
          '<td class="govuk-table__cell" data-type="select-one" data-val=' +
            grantSectionId +
            "></td>",
        );
        var jsonObj = {
          grantSectionId: { value: grantSectionId, text: grantSection },
          paymentsThreshold: paymentsThreshold,
          abatementsThreshold: abatementsThreshold,
        };
        thresholdObj["thresholds"][i] = jsonObj;
        var $td2 = $(
          '<td class="govuk-table__cell" id="paymentsThreshold"></td>',
        );
        var $td3 = $(
          '<td class="govuk-table__cell" id="abatementsThreshold"></td>',
        );
        var $td4 = $(
          '<td class="grant_section_actions govuk-table__cell"></td>',
        );
        $td1.text(grantSection);
        $td2.text(paymentsThreshold);
        $td3.text(abatementsThreshold);
        $tr.append($td1);
        $tr.append($td2);
        $tr.append($td3);
        var $remove = $(
          '<button class="js-table-btn" data-buttontype="remove" data-th-attr="data-id=${i.index}">remove</button>',
        ).on("click", removeClickEvent);
        $td4.append($remove);
        $tr.append($td4);
        $table.append($tr);
        i++;
      }
    });
    updateHiddenJsonObj($table);
    var totalSection = $("#totalGrantSections").val();
    $("#fractionValue").text(i);
  }

  function removeClickEvent(e) {
    popupFlag = true;
    $(this).closest("tr").remove();
    var $table = $("table");
    updateHiddenJsonObj($table);
  }

  function addToTable(row) {
    var rowDataObject = {};
    var $table = $("table tbody");
    var $tr = $('<tr class="govuk-table__row"></tr>');
    var selectObj;
    row.find("td").each(function () {
      if ($(this)[0].outerHTML.includes("<select")) {
        selectObj = $(this).find("select :selected");
        var $td = $(
          '<td class="govuk-table__cell" data-type="select-one" data-val=' +
            selectObj.val() +
            "></td>",
        );
        $td.text(selectObj.text());
        var grantObj = {
          grantSectionId: {
            value: selectObj.val(),
            text: selectObj.text(),
          },
        };
        $tr.append($td);
      } else if ($(this)[0].outerHTML.includes("<input")) {
        var inputObj = $(this).find("input");
        var $td = $(
          '<td class="govuk-table__cell" id=' + inputObj.attr("id") + "></td>",
        );
        if (inputObj.val() == "") {
          $td.text("0");
        } else {
          $td.text(inputObj.val());
        }
        $tr.append($td);
      } else {
        var $remove = $(
          '<button type="button" class="threshold-remove" data-buttontype="remove">remove</button>',
        ).on("click", removeClickEvent);
        var $td = $('<td class="govuk-table__cell"></td>');
        $td.append($remove);
        $tr.append($td);
      }
    });
    if (selectObj.text().length > 0) {
      $table.append($tr);
      $("#grantSectionId").val("").trigger("chosen:updated");
      $("table input").val("");
      updateHiddenJsonObj($table);
    }
    $("#submitTable").val("Save thresholds for the approver");
  }

  function updateHiddenJsonObj($table) {
    var thresholdObj = { thresholds: [] };
    var i = 0;
    $table.find("tr").each(function () {
      var jsonObj = [];
      var grantSectionObj = {};
      $(this)
        .find("td")
        .each(function () {
          if ($(this).attr("data-type") == "select-one") {
            grantSectionObj["grantSectionId"] = {
              value: $(this).attr("data-val"),
              text: $(this).text(),
            };
          }
          if ($(this).attr("id") == "paymentsThreshold") {
            grantSectionObj["paymentsThreshold"] = $(this).text();
          }
          if ($(this).attr("id") == "abatementsThreshold") {
            grantSectionObj["abatementsThreshold"] = $(this).text();
          }
        });
      thresholdObj["thresholds"][i] = grantSectionObj;
      i++;
    });
    $(".js-table-object").val(JSON.stringify(thresholdObj));
  }
}
